import { EntityState } from "@ngrx/entity";

import { LandingPageEntity } from '../entities';

export interface LandingPageState extends EntityState<LandingPageEntity> {
    selectedId: number,
    isLoading: boolean,
    isLoaded: boolean,
    prevUrl: string,
    nextUrl: string,
    totalCount: number
}